import __C from '../../../../../../includes/primitives/_constant_'

export default {
    Canvas: {
      CanvasWidth: 700,
      CanvasHeight: 420,
      CanvasBorderWeight: 0.5,
      CanvasBorderColor: '#757575',
      CanvasFillColor: 'Transparent',
      CanvasOpacity: 0.2,

      CanvasChartX: 0,
      CanvasChartY: 0,
      CanvasChartWidth: 1300,
      CanvasChartHeight: 760,
      CanvasChartBorderWeight: 0,
      CanvasChartBorderColor: '#757575',
      CanvasChartFillColor: '#757575',
      CanvasChartOpacity: 0,
      CanvasChartSpace: 0,

      CanvasFontFamily: 'roboto',
    },
    Text: {
      Text: [
        { text: 'Weight : ', x:240, y: 0, font: 'roboto', class: 'regular', size: 11, color: '#BCBCBC', align: 'start' },
      ],
      Filter: [
        { name: 'MOD'   , x: 240, y: 0, font: 'roboto', class: 'regular', size: 12, color: '#313131', align: 'end' },
      ],
      Sql: [
        {
          query: "SELECT 'PBF COMPESSOR AIR COOLER - TRAIN 4' TITLE", 
          text: 'Data Source',
          x: 240,
          y: 0,
          font: 'roboto',
          style: 'regular',
          size: 11,
          color: '#44A9DF',
          align: 'end'
        },
      ]
    },
    DataItems: [
      {PRIORITY:"P1A",TOTAL:3863,DONE:2355,NOT_DONE:1508,DONE_PROG:61,NOT_DONE_PROG:39},
      {PRIORITY:"P1B",TOTAL:4080,DONE:540,NOT_DONE:3540,DONE_PROG:13.2,NOT_DONE_PROG:86.8},
      {PRIORITY:"P1",TOTAL:25869,DONE:10040,NOT_DONE:15829,DONE_PROG:38.8,NOT_DONE_PROG:61.2},
      {PRIORITY:"P2",TOTAL:26000,DONE:7733,NOT_DONE:18267,DONE_PROG:29.7,NOT_DONE_PROG:70.3},
      {PRIORITY:"P3",TOTAL:20898,DONE:6600,NOT_DONE:14298,DONE_PROG:31.6,NOT_DONE_PROG:68.4},
      {PRIORITY:"No Subsys defined in EP",TOTAL:144,DONE:2,NOT_DONE:142,DONE_PROG:1.4,NOT_DONE_PROG:98.6}
    ],
}